import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "card"
};
const _hoisted_2 = {
  class: "flex flex-nowrap overflow-hidden card-container"
};
const _hoisted_3 = {
  class: "flex align-items-center justify-content-center m-2 border-round"
};
const _hoisted_4 = {
  class: "flex align-items-center justify-content-center m-2 border-round"
};
const _hoisted_5 = {
  class: "col-12 md:col-12",
  style: {
    "width": "300px"
  }
};
const _hoisted_6 = {
  class: "p-inputgroup"
};
const _hoisted_7 = {
  key: 0,
  class: "card"
};
const _hoisted_8 = {
  class: "flex flex-nowrap overflow-hidden card-container",
  style: {
    "max-width": "500px"
  }
};
const _hoisted_9 = {
  class: "flex align-items-center justify-content-center text-black border-round",
  style: {
    "margin-right": "12px"
  }
};
const _hoisted_10 = {
  class: "flex align-items-center justify-content-center text-black border-round"
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "card"
};
const _hoisted_13 = {
  class: "flex flex-nowrap overflow-hidden card-container green-container",
  style: {
    "max-width": "500px"
  }
};
const _hoisted_14 = {
  class: "flex align-items-center justify-content-center font-bold text-black m-2 border-round"
};
const _hoisted_15 = {
  class: "flex align-items-center justify-content-center font-bold text-black m-2 border-round"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FileUpload = _resolveComponent("FileUpload");

  const _component_Button = _resolveComponent("Button");

  const _component_Image = _resolveComponent("Image");

  const _component_Dropdown = _resolveComponent("Dropdown");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_FileUpload, {
    name: "demo[]",
    mode: "basic",
    accept: _ctx.fileType,
    chooseLabel: "上传文件",
    auto: true,
    multiple: true,
    onSelect: _ctx.upload_files
  }, null, 8, ["accept", "onSelect"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Button, {
    icon: "pi pi-times",
    class: "p-button-danger",
    disabled: !_ctx.selectedFile,
    onClick: _ctx.remove_file
  }, null, 8, ["disabled", "onClick"]), _createVNode(_component_Dropdown, {
    modelValue: _ctx.selectedFile,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.selectedFile = $event),
    options: _ctx.files,
    placeholder: "选择文件"
  }, {
    value: _withCtx(slotProps => [slotProps.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_Image, {
      src: slotProps.value.base64,
      preview: "",
      height: "14",
      width: "14"
    }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_10, _toDisplayString(slotProps.value.fileName), 1)])])) : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(slotProps.placeholder), 1))]),
    option: _withCtx(slotProps => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_Image, {
      src: slotProps.option.base64,
      height: "32",
      width: "32"
    }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_15, _toDisplayString(slotProps.option.fileName), 1)])])]),
    _: 1
  }, 8, ["modelValue", "options"]), _createVNode(_component_Button, {
    icon: "pi pi-download",
    class: "p-button-primary",
    disabled: !_ctx.selectedFile,
    onClick: _ctx.download_file
  }, null, 8, ["disabled", "onClick"])])])])])]);
}